export default __webpack_public_path__ + "static/media/footer_logo.2c952762.png";